import type { ReactNode } from "react";

import { Column } from "@hightouch/htui";

type CardFrameProps = {
  children: ReactNode;
  /** Responds to hover, so parts inside it can react with `_groupHover`. */
  isInteractive?: boolean;
  isSelected?: boolean;
};

/** A gallery card's outline: a preview across the top, then a footer. A link inside it stretches over the whole card. */
export const CardFrame = ({
  children,
  isInteractive = false,
  isSelected = false,
}: CardFrameProps) => (
  <Column
    as="li"
    data-group={isInteractive ? "" : undefined}
    position="relative"
    isolation="isolate"
    minWidth={0}
    bg="white"
    borderRadius="3xl"
    boxShadow="sm"
    outline={isSelected ? "2px solid" : undefined}
    outlineColor="primary.base"
  >
    {children}
  </Column>
);

/** The card's details below its preview. */
export const CardFooter = ({ children }: { children: ReactNode }) => (
  <Column
    // A flex item stacks on z-index unpositioned, so the footer's shadow sits over the preview while a link's overlay still spans the card.
    zIndex={1}
    gap={2}
    p={3}
    bg="whiteAlpha.80"
    borderBottomRadius="3xl"
    boxShadow="sm"
  >
    {children}
  </Column>
);
